import * as angular from "angular";
import {IController} from "angular";
import {PlanningViewSettingsModel} from "../../../models/planning-view-settings.model";

export class PlanningDraftRoutesSettingsPanelTemplateComponent implements IController {

  showRoutes?: boolean;
  showStops?: boolean;
  settings: PlanningViewSettingsModel;
  isDrillDown?: boolean;
  panelRef: any;

  public settingsCopy: PlanningViewSettingsModel;
  public enabledSections: {
    routesColumns: boolean;
    routeColumns: boolean;
    load: boolean;
    capacity: boolean;
  };

  $onInit() {
    this.settingsCopy = angular.copy(this.settings);
    this.enabledSections = {
      routesColumns: true,
      routeColumns: true,
      load: true,
      capacity: true
    }
  }

  onChangeRoutesColumns(columnKey, isEnabled) {
    this.settingsCopy.routes.columns[columnKey] = isEnabled;
  }

  onChangeRouteColumns(columnKey, isEnabled) {
    this.settingsCopy.route.columns[columnKey] = isEnabled;
  }

  onChangeLoad(loadKey, isEnabled) {
    this.settingsCopy.routes.load[loadKey] = isEnabled;
    this.settingsCopy.route.load[loadKey] = isEnabled;
  }

  onChangeCapacity(loadKey, isEnabled) {
    this.settingsCopy.routes.capacity[loadKey] = isEnabled;
    this.settingsCopy.route.capacity[loadKey] = isEnabled;
  }

  onSubmit() {
    this.panelRef.config.onCloseSuccess(this.panelRef, 'Submit', this.settingsCopy);
  }

  onReset() {
    this.panelRef.config.onCloseSuccess(this.panelRef, 'Reset');
  }

  onCancel() {
    this.panelRef.config.onCloseSuccess(this.panelRef, 'Cancel');
  }

}

angular
  .module('bringoz.admin.agents')
  .component('planningDraftRoutesSettingsPanelTemplate', {
    bindings: {
      showRoutes: '<?',
      showStops: '<',
      settings: '<',
      isDrillDown: '<?',
      panelRef: '<'
    },
    template: require('./planning-draft-routes-settings-panel-template.html').default,
    controller: PlanningDraftRoutesSettingsPanelTemplateComponent
  });
